export const appConfig = (baseUrl: string): string => `${baseUrl}/profile/v1/app-config`;
